import { http } from "../http/Http";
import { AuditLogEntity } from "../models/AuditLogEntity";
import { ServiceResponse } from "../models/ServiceResponse";

export class AuditLogEntityService {

    getAuditLogEntities = async (): Promise<ServiceResponse<AuditLogEntity[]>> => {
        const { data } = await http.get<ServiceResponse<AuditLogEntity[]>>("AuditLogEntity/GetAll");
        return data;
    };

}